/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  var swiper = new Swiper(".mySwiper", {
		  slidesPerView: 1,
		  
		  pagination: {
			el: ".swiper-pagination",
			clickable: true,
		  },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
	  on: { 
	slideChangeTransitionStart: function(s) {
		var currentSlide = s.realIndex;
		console.log(s.realIndex);
        var nex = document.getElementsByClassName('swiper-button-next');			
		//slide 2
		var a = document.getElementsByClassName('iss-slide-two-bubble');			
		var b = document.getElementsByClassName('iss-slide-two-img-top');
		var c = document.getElementsByClassName('iss-slide-two-dotted');
		var d = document.getElementsByClassName('iss-slide-two-img-btm');
		var e = document.getElementsByClassName('iss-slide-two-text');		
			//slide 3
		var f = document.getElementsByClassName('iss-slide-three-img');
		var g = document.getElementsByClassName('iss-slide-three-text');
		//slide 4
		//var h = document.getElementsByClassName('iss-slide-four-dotted');
		var i = document.getElementsByClassName('iss-slide-four-img');
		var j = document.getElementsByClassName('iss-slide-four-bubble');
		var k = document.getElementsByClassName('iss-slide-title');
        //slide 5
        var l = document.getElementsByClassName('iss-slide-five-img');
		var m = document.getElementsByClassName('iss-slide-five-text');
        var n = document.getElementsByClassName('iss-slide-five-dotted');
        if(currentSlide == 0){
          document.getElementById('story-begin').style.display = '';
          nex[0].classList.add("animate__animated", "animate__pulse"); 
        }else{
          document.getElementById('story-begin').style.display = 'none';
          nex[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
        }
      
		if(currentSlide == 1){
			a[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
			b[0].classList.add("animate__animated", "animate__fadeInTopRight");
			c[0].classList.add("animate__animated", "animate__fadeInLeft");
			d[0].classList.add("animate__animated", "animate__fadeInBottomLeft");
			e[0].classList.add("animate__animated", "animate__fadeInBottomRight");			
		}else{
			a[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
			b[0].classList.remove("animate__animated", "animate__fadeInTopRight");
			c[0].classList.remove("animate__animated", "animate__fadeInLeft");
			d[0].classList.remove("animate__animated", "animate__fadeInBottomLeft");
			e[0].classList.remove("animate__animated", "animate__fadeInBottomRight");			
		}
		if(currentSlide == 2){
			g[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
			f[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
		}else{
			g[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
			f[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
		}
		if(currentSlide == 3){
            //console.log('SLIDE 3');
			//h[0].classList.add("animate__animated", "animate__fadeInLeft"); 
			i[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
			j[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
			k[0].classList.add("animate__animated", "animate__fadeInTopRight"); 			
		}else{
			//h[0].classList.remove("animate__animated", "animate__fadeInLeft"); 
			i[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
			j[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
			k[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
		}
        if(currentSlide == 4){
            //console.log('SLIDE 4');
			l[0].classList.add("animate__animated", "animate__fadeInTopRight"); 
			m[0].classList.add("animate__animated", "animate__fadeInTopRight");
            n[0].classList.add("animate__animated", "animate__fadeInTopRight");
		}else{
			l[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
			m[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
            n[0].classList.remove("animate__animated", "animate__fadeInTopRight"); 
		}

	},
	slideChangeTransitionEnd: function(s) {
		var currentSlide = s.activeIndex;
		console.log(currentSlide + 'end');
	}
	  }
		});
		



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();





